import React from "react";

export default function HeadingNavbar() {
  return (
    <div className="header_navbar">
      <div className="container-fluid">
        <div className="row">
          <div className="text-light HeadingNavbartext text-center p-0 fw-500 m-0">
            <div className="scrolling-content">
              <span>Serving All Over Gujarat</span>
              <span>
                Water Filters, Geysers, Pumps & Membranes available
              </span>
              <span>Professional Installation & Service</span>
              <span>Trusted for 10+ Years</span>
              <span>Call Now: +91 92651 99516</span>
              <span>Email: blisswatertechnology@gmail.com</span>
              <span>Serving All Over Gujarat</span>
              <span>
                Water Filters, Geysers, Pumps & Membranes available
              </span>
              <span>Professional Installation & Service</span>
              <span>Trusted for 10+ Years</span>
              <span>Call Now: +91 92651 99516</span>
              <span>Email: blisswatertechnology@gmail.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
